import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
//	   httpUrl: "http://chain.qiyiguo.xin",
//	   httpUrl: "http://172.6.8.254",
//	   httpUrl: "/api",
//   	  httpUrl: "/minghao",
	  // oldhttpUrl: "http://localhost:8080/",
	  // httpUrlImg: "http://chain.qiyiguo.xin",
	  // httpUrl: "https://sxctest.sgscf.com/",
	  // oldhttpUrl: "https://sxtest.sgscf.com/",
	  // httpUrlImg: "https://sxctest.sgscf.cn/",
	  httpUrl: "https://sxc.sgscf.com/",
	  oldhttpUrl: "https://sx.sgscf.com/",
	  // httpUrlImg: "https://sxc.sgscf.cn/",
	  pageSize: 10,


  },
  mutations: {
	  
  },
  actions: {
  },
  modules: {
  }
})
